export const useDummyAddonPacks = false;

export const dummyAddOnPacks = {
    addon_packs: [
        {
            id: 1,
            name: "5 Users Pack",
            type: "USER",
            value: 5, // eg: (5, 500, 100, 5000, 5),
            monthly_stripe_price_id: "Integer",
            monthly_price: 6.90, // price per pack, ie: (6.90, 14.90, 14.90, 14.90, 6.90)
            yearly_stripe_price_id: "Integer",
            yearly_price: 69, // price per pack, ie: (69, 149, 149, 149, 69)
            created_at: "Date",
            updated_at: "Date",
        },
        {
            id: 2,
            name: "500 Pages Data Extraction Pack",
            type: "DATA_EXTRACTION",
            value: 500,
            monthly_stripe_price_id: "Integer",
            monthly_price: 14.90, // price per pack, ie: (6.90, 14.90, 14.90, 14.90, 6.90)
            yearly_stripe_price_id: "Integer",
            yearly_price: 149, // price per pack, ie: (69, 149, 149, 149, 69)
            created_at: "Date",
            updated_at: "Date",
        },
        {
            id: 3,
            name: "100 Files WhatsApp Pack",
            type: "WHATSAPP",
            value: 100,
            monthly_stripe_price_id: "Integer",
            monthly_price: 14.90, // price per pack, ie: (6.90, 14.90, 14.90, 14.90, 6.90)
            yearly_stripe_price_id: "Integer",
            yearly_price: 149, // price per pack, ie: (69, 149, 149, 149, 69)
            created_at: "Date",
            updated_at: "Date",
        },
        {
            id: 4,
            name: "5000 Emails Pack",
            type: "EMAIL",
            value: 5000,
            monthly_stripe_price_id: "Integer",
            monthly_price: 14.90, // price per pack, ie: (6.90, 14.90, 14.90, 14.90, 6.90)
            yearly_stripe_price_id: "Integer",
            yearly_price: 149, // price per pack, ie: (69, 149, 149, 149, 69)
            created_at: "Date",
            updated_at: "Date",
        },
        {
            id: 5,
            name: "5GB Storage Pack",
            type: "STORAGE",
            value: 5,
            monthly_stripe_price_id: "Integer",
            monthly_price: 6.90, // price per pack, ie: (6.90, 14.90, 14.90, 14.90, 6.90)
            yearly_stripe_price_id: "Integer",
            yearly_price: 69, // price per pack, ie: (69, 149, 149, 149, 69)
            created_at: "Date",
            updated_at: "Date",
        },
    ],
};

export const useDummyQuotas = false;
export const dummyQuotas = {
    quotas: [
        {
            type: "TRANSACTION",
            period: "2024-01-01",
            period_type: "MONTHLY",
            utilisation: 5,
            allocation_total: null,
            allocation_addon_packs: null,
            allocation_plan: null,
        },
        {
            type: "DATA_EXTRACTION",
            period: "2024-01-01",
            period_type: "MONTHLY",
            utilisation: 0,
            allocation_total: 1000,
            allocation_addon_packs: 0,
            allocation_plan: 1000,
        },
        {
            type: "WHATSAPP",
            period: "2024-01-01",
            period_type: "MONTHLY",
            utilisation: 0,
            allocation_total: 200,
            allocation_addon_packs: 0,
            allocation_plan: 200,
        },
        {
            type: "EMAIL",
            period: "2024-01-01",
            period_type: "MONTHLY",
            utilisation: 4,
            allocation_total: 10000,
            allocation_addon_packs: 0,
            allocation_plan: 10000,
        },
        {
            type: "FLOW",
            period: "2024-01-01",
            period_type: "MONTHLY",
            utilisation: 500,
            allocation_total: 600,
            allocation_addon_packs: 0,
            allocation_plan: 600,
        },
        {
            type: "STORAGE",
            period: null,
            period_type: null,
            utilisation: 137900244,
            allocation_total: 26843545600,
            allocation_addon_packs: 5368709120,
            allocation_plan: 21474836480,
        },
        {
            type: "USER",
            period: null,
            period_type: null,
            utilisation: 7,
            allocation_total: null,
            allocation_addon_packs: null,
            allocation_plan: null,
        },
    ],
};
